import { useEffect, useRef, useState } from 'react';
import BaseApi from '../../../services/BaseApi';
import Modal from '../../Modal';

export interface AddressResult { id: string; label: string; latitude: number; longitude: number; }

export default function AddressSearch({ onSelect }: { onSelect: (address: AddressResult) => void }) {
  const [query, setQuery] = useState('');
  const [selected, setSelected] = useState(false);
  const [results, setResults] = useState<AddressResult[]>([]);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const revision = useRef(0);
  useEffect(() => {
    const current = ++revision.current;
    setResults([]); setError(''); setBusy(false);
    if (query.trim().length < 5 || selected) return;
    let active = true;
    const controller = new AbortController();
    const timer = window.setTimeout(async () => {
      setBusy(true);
      try {
        const values: any = await BaseApi.get('api/address/search', { params: { query: query.trim() }, signal: controller.signal });
        if (active && current === revision.current) setResults(values);
      } catch (e) {
        if (active && !controller.signal.aborted && current === revision.current) setError(Modal.getErrorMessageText(e));
      } finally {
        if (active && current === revision.current) setBusy(false);
      }
    }, 700);
    return () => { active = false; window.clearTimeout(timer); controller.abort(); };
  }, [query, selected]);
  return <div className="border rounded p-3 mb-3">
    <label htmlFor="viability-address">Buscar endereÃ§o da instalaÃ§Ã£o</label>
    <input id="viability-address" className="form-control" type="search" autoComplete="off" maxLength={200}
      placeholder="Rua, nÃºmero, cidade e estado" value={query} aria-describedby="viability-address-help"
      onChange={e => { revision.current++; setSelected(false); setQuery(e.target.value); }} />
    <small id="viability-address-help">Digite pelo menos 5 caracteres e selecione um endereÃ§o para preencher as coordenadas.</small>
    <div role="status" aria-live="polite">
      {busy && <p className="mb-1">Buscando endereÃ§os...</p>}
      {!busy && !error && !selected && query.trim().length >= 5 && results.length === 0 && <p className="mb-1">Se nenhum endereÃ§o aparecer, inclua a cidade e o estado ou informe as coordenadas manualmente.</p>}
      {selected && <p className="text-success mb-1">Coordenadas preenchidas. Confira o local antes de salvar.</p>}
    </div>
    {error && <div role="alert" className="text-danger">{error}</div>}
    {results.length > 0 && <ul className="list-group mt-2" aria-label="EndereÃ§os encontrados">
      {results.map((address, index) => <li className="list-group-item p-0" key={`${address.id}-${index}`}>
        <button type="button" className="btn text-start w-100" onClick={() => {
          revision.current++; setQuery(address.label); setSelected(true); setResults([]); onSelect(address);
        }}>{address.label}</button>
      </li>)}
    </ul>}
    <small className="d-block mt-2">Busca: Photon Â· <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener noreferrer">Â© OpenStreetMap contributors</a></small>
  </div>;
}
